
import React from 'react';
import { Button } from '@/components/ui/button';

interface CompletedDayNotificationProps {
  dayNumber: number;
  goToNextDay: () => void;
}

const CompletedDayNotification: React.FC<CompletedDayNotificationProps> = ({ dayNumber, goToNextDay }) => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-2xl p-6 my-6 text-center">
      <h3 className="text-xl font-medium text-green-800 mb-2">
        You've already completed Day {dayNumber}!
      </h3>
      <p className="text-green-700 mb-4">
        {dayNumber === 30 
          ? "Congratulations on completing the entire 30-day journey! You're well on your way to better hormone health."
          : "Great job keeping up with your hormone health journey."}
      </p>
      {dayNumber < 30 && (
        <Button onClick={goToNextDay}>
          Continue to Next Day
        </Button>
      )}
    </div>
  );
};

export default CompletedDayNotification;
